<app-form-screenbsk
    [tagList]="tagList"
    [basketList]="basketList"
    [request]="selectedRequest"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)">
</app-form-screenbsk>
